import React from "react";

import { Box, Text } from "@showitinc/showit-wc";
import AppConstants from "../../constants/AppConstants";
import HelpTooltip from "../HelpTooltip";
import { elementSyncUtils } from "../../utils/SyncUtils";
import { getProp } from "../../utils/Merge/MergeUtils.mjs";
import ColorPicker from "../../app2components/base/ColorPicker";
import SplitMergeWrapper from "../../app2components/base/SplitMergeWrapper";
import { FLYOUT_SHIFT_RIGHT } from "../../constants/UIConstants";
import { initFormatter } from "../../utils/PropertyFormatters";
import styles from "./DesignSettings.module.css";

const { THEME_BG_PROPERTY_COLOR } = AppConstants;

const DesignSettingsGlobal = ({ onChange, newTheme, selectedLayout, bgPalette }) => {
  const { isSynced, toggleSyncedProp, getPropName } = elementSyncUtils(
    newTheme,
    onChange,
    selectedLayout
  );
  const bgColor = getProp(newTheme, selectedLayout, [THEME_BG_PROPERTY_COLOR]);
  const { onChange: onFormatChange } = initFormatter(onChange, getPropName);

  const handleBeforeChange = onFormatChange(THEME_BG_PROPERTY_COLOR, bgColor);
  const handleChange = onFormatChange(THEME_BG_PROPERTY_COLOR, bgColor);
  const handleInput = onFormatChange(THEME_BG_PROPERTY_COLOR, bgColor, false);

  return (
    <div>
      <Box d="flex" justify="between" align="center">
        <Text className={`${styles["global-settings-header"]} panel-subheading`}>Global Styles</Text>
        <HelpTooltip tooltipKey="design-global-settings" />
      </Box>

      <div className="panel-section-content">
        <SplitMergeWrapper
          sync={isSynced(THEME_BG_PROPERTY_COLOR)}
          layout={selectedLayout}
          toggleSync={() => toggleSyncedProp(THEME_BG_PROPERTY_COLOR)}
        >
          <ColorPicker
            hideAlpha
            color={bgColor}
            context
            shift={FLYOUT_SHIFT_RIGHT}
            customPalette={bgPalette}
            themeOnly
            onSIBeforeChange={handleBeforeChange}
            onSIChange={handleChange}
            onSIInput={handleInput}
          />
        </SplitMergeWrapper>
      </div>
    </div>
  );
};

export default DesignSettingsGlobal;
